import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import imageUrl from '../../assets/Images/TopBanner.png';

const MetaHelmet = ({ title, description }) => (
  <Helmet prioritizeSeoTags>
    <link href={window.location.href} rel="Canonical" />
    <title>{title}</title>
    <meta content={description} name="description" />
    <meta content={window.location.href} property="og:url" />
    <meta content={title} property="og:title" />
    <meta content={description} property="og:description" />
    <meta property="og:image" content={imageUrl} />

    <meta content={window.location.href} property="twitter:url" />
    <meta content={title} property="twitter:title" />
    <meta content={description} property="twitter:description" />
    <meta name="twitter:image" content={imageUrl} />
  </Helmet>
);

MetaHelmet.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default MetaHelmet;
